import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../redux/store';
import { businessActions } from '../redux/slices/businessSlice';

export const useBusinessSelection = () => {
  const dispatch = useDispatch();
  const {
    id: business,
    departments = [],
    availableBusinesses = [],
  } = useSelector((state: RootState) => state.business);

  const showBusinessStep = availableBusinesses.length > 1;

  const selectBusiness = useCallback(
    (businessId: number) => {
      const selected = availableBusinesses.find(b => b.id === businessId);
      if (selected) {
        dispatch(businessActions.login({ ...selected, availableBusinesses }));
        return selected.departments[0]?.activationCode || '';
      }
      return '';
    },
    [availableBusinesses, dispatch]
  );

  const selectDepartment = useCallback((activationCode: string) => {
    // ✅ SIMPLY RETURN THE ACTIVATION CODE
    // The activationCode is already being stored in the registration form context
    return activationCode;
  }, []);

  return {
    business,
    departments,
    availableBusinesses,
    showBusinessStep,
    selectBusiness,
    selectDepartment,
  };
};
